module.exports = __webpack_public_path__ + "static/media/Drapion_gaussian2.f11e4ec2.png";